export const vacinador = {
  nome: 'Vacinador(a)',
  id_perfil: 13,
  dashboard: [
    {
      link: '',
      titulo: 'Pódio e equipes por classificação',
      icone: false,
      imagem: '',
      svg: '',
      key: 'modal_ranking_indicadores_aps',
      type: 'modal',
    },
    {
      link: '/gestao-cadastros',
      titulo: 'Gestão cadastros',
      icone: false,
      imagem: '',
      svg: 'GestaoCadastros',
      key: 'gestao_cadastros',
    },
    {
      link: '/atendimentos-no-mes/profissional',
      titulo: 'Relatório atendimentos',
      icone: 'icofont-list',
      key: 'atendimentos_no_mes',
    },
    {
      link: '/imunizacao',
      titulo: 'Imunização',
      icone: false,
      imagem: require('@/assets/icones/imunizacao.png'),
      key: 'imunizacao',
    },
    {
      link: '/oficinas-treinamentos',
      titulo: 'Oficinas Reuniões Treinamentos',
      icone: 'icofont-presentation',
      key: 'oficinas_treinamentos',
      featured: true,
    },
    {
      link: '/upa',
      titulo: 'UPA',
      icone: 'icofont-hospital',
      key: 'upa',
    },
  ],
  administracao: [],
  gestao_cadastros: [
    {
      link: '/cidadao/painel',
      titulo: 'Cidadão',
      icone: 'icofont-users-alt-4',
      key: 'cidadao',
      // openNewTab: true,
      // callback: function (ctx, navigate) {
      //   const parceiro = ctx.$store.state?.infoMunicipio?.parceiro
      //   if (parceiro == null) {
      //     navigate(this.link, this.openNewTab)
      //   } else {
      //     ctx.$toast.error('Não disponível.', '', { position: 'topRight' })
      //   }
      // },
    },
  ],
  visitas_domiciliares: [],
  imunizacao: [
    {
      link: '/importar-vacinas',
      titulo: 'Importar vacinas',
      icone: false,
      imagem: '',
      svg: 'ImportarVacinas',
      key: 'imunizacao_importar_vacinas',
    },
    {
      link: '/vacina-idade-certa',
      titulo: 'Vacina idade certa',
      icone: false,
      imagem: require('@/assets/icones/situacao_vacinal.png'),
      key: 'vacina_idade_certa',
    },
    {
      link: '/campanha-gripe',
      titulo: 'Campanha gripe',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/campanha-gripe.png'),
      key: 'campanha_gripe',
    },
    {
      link: '/divergencias-vacinas',
      titulo: 'Divergências vacinas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/inconsistencias.png'),
      key: 'divergencia_vacinas',
    },
    {
      link: '/dose-imunizante',
      titulo: 'Dose Imunizante',
      icone: 'icofont-injection-syringe',
      key: 'dose_imunizante',
    },
  ],
  vacina_idade_certa: [
    {
      link: '/faltosos-vacinas-0-15-anos',
      titulo: '0 - 15 anos',
      icone: false,
      imagem: require('@/assets/icones/2anos.png'),
      key: 'faltosos_2_anos',
    },
    {
      link: '/hpv-quadrivalente',
      titulo: 'HPV quadrivalente',
      icone: false,
      imagem: require('@/assets/icones/hpv.png'),
      key: 'hpv_quadrivalente',
    },
    {
      link: '/acwy',
      titulo: 'Meningocócica ACWY',
      icone: false,
      imagem: require('@/assets/icones/acwy.png'),
      key: 'meningococica_acwy',
    },
    {
      link: '/covid19-infantil',
      titulo: 'COVID-19 Infantil',
      icone: false,
      imagem: '',
      svg: 'Covid19Infantil',
      key: 'covid19_infantil',
    },
    {
      link: '/criancas-dtp-em-atraso',
      titulo: 'DTP',
      icone: false,
      imagem: '',
      svg: 'Dtp',
      key: 'criancas_dtp_em_atraso',
    },
    {
      link: '/pneumococica-10v',
      titulo: 'Pneumocócica 10V (conjugada)',
      icone: false,
      imagem: '',
      svg: 'Pneumo',
      key: 'pneumococica_10V',
    },
    {
      link: '/triplice-viral',
      titulo: 'Tríplice viral',
      icone: false,
      imagem: '',
      svg: 'TripleceViral',
      key: 'triplice_viral',
    },
    {
      link: '/varicela',
      titulo: 'Varicela',
      icone: false,
      imagem: '',
      svg: 'Varicela',
      key: 'varicela',
    },
    {
      link: '/tetra-viral',
      titulo: 'Tetra viral',
      icone: 'icofont-injection-syringe',
      key: 'tetra_viral',
    },
    {
      link: '/vacina-dengue',
      titulo: 'Vacina Dengue',
      icone: 'icofont-injection-syringe',
      key: 'vacina_dengue',
    },
  ],
  divergencia_vacinas: [
    {
      link: '/divergencias-vacinas/vacinas-nao-enviadas',
      titulo: 'Vacinas não enviadas',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_nao_enviadas.png'),
      key: 'vacinas_nao_enviadas',
    },
    {
      link: '/divergencias-vacinas/d3-antes-6',
      titulo: 'D3 antes 6 meses',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/D3.png'),
      key: 'd3_antes_6_meses',
    },
    {
      link: '/divergencias-vacinas/vacinas-nascimento-divergente',
      titulo: 'Vacinas nascimento divergente',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_nascimento_divergente',
    },
    {
      link: '/divergencias-vacinas/vacinas-sem-cadastro',
      titulo: 'Vacinas sem cadastro',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/vacinas_sem_cadastro.png'),
      key: 'vacinas_sem_cadastro',
    },
    {
      link: '/divergencias-vacinas/vacinas-antes-nascimento',
      titulo: 'Vacinas antes nascimento',
      icone: false,
      imagem: require('@/assets/icones/IconesVacinas/nascimento_divergente.png'),
      key: 'vacinas_antes_nascimento',
    },
  ],
  indicadores_aps: [],
  pre_natal: [],
  doencas_cronicas: [],
  desempenho_por_equipe: [],
  saude_crianca: [],
  producao: [],
  vinculo_acompanhamento: [],
  bpa_e_ras: [],
  saude_bucal: [],
  esf_eap: [],
  emulti: [],
  oficinas_treinamentos: [
    {
      link: '/oficinas-treinamentos-participante',
      titulo: 'Sou Participante',
      icone: 'icofont-user',
      key: 'oficinas_treinamentos_participante',
    },
    {
      link: '/oficinas-treinamentos-certificados',
      titulo: 'Meus Certificados',
      icone: 'icofont-certificate',
      key: 'oficinas_treinamentos_certificados',
    },
  ],
  upa: [
    {
      link: '/atendimentos-pessoa',
      titulo: 'Atendimentos pessoa',
      icone: false,
      imagem: '',
      svg: 'Acompanhamento',
      key: 'atendimentos_pessoa',
      ajudaKey: 'upa_atendimentos_pessoa',
    },
  ],
}
